 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		44: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "" + chunkId + "." + {"0":"283582af44cc440ea977","1":"5b0e142b3fc7b104a0b5","2":"186ef348e15f01f61e44","3":"4b7abb9cdadec525610f","4":"14647ee2adeaf6476884","5":"996c391c24c749c4c300","6":"cb13787fc3cc8398f3e8","7":"fd94dbb02efc4db182d4","8":"74d54ccc7e5f9c4196ce","9":"3e9d331b48d97f71d99d","10":"f5eeeaba301f0f05d2f6","11":"3cf7ae687e0fd0086df4","12":"5cb844fe03c4009b8554","13":"af0b1d8b6af6887f8432","14":"ba85d592777f81c37120","15":"67d0a8ed49f197b5b0d2","16":"aec1e4edd12a65bb8b4d","17":"9fcd54ab554244e6c6e0","18":"e9b0ebefb425f644ac14","19":"1b553691aa53ebcc7db4","20":"ba2e1069da6a89ebd0ab","21":"2af11d6c25b73543106d","22":"9566856b750e5ce7af03","23":"5a10d5d51b06529a547b","24":"2b165abbb7eb2a629c97","25":"11708a87135ef0adefcf","26":"9d2c02ca4551d54d3025","27":"69dc192ca010e5a9a45c","28":"c45f98ebc39c2c7a38f4","29":"97790f08ba0d30a15cb5","30":"9fa10a3faaf91b630284","31":"a3303ebed101226b6f90","32":"65e5107cae00d33d4517","33":"0cfc3db3e051e637e1f6","34":"0f472b2a6bccddbf5312","35":"d46b9d613aa40110d37f","36":"86a431d2e849f529167d","37":"d5e848b08cdc76300f25","38":"4f510e006da792b1c996","39":"c77ede3b65e6a7398c5b","40":"8d49332a919659b460ef","41":"8809d3b6643883d0cab7","42":"67dd408e7821d4839d1a","43":"53a3e841033b20450775"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/css-puns/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 154);



// WEBPACK FOOTER //
// webpack/bootstrap 775ffd5bb912b4d2889c